import { Product } from '@services/product/types/product';

export const isEntryLevelPlan = (product: Product) => {
  if (product.category.toUpperCase() === 'PLAN') {
    return ['BASIC', 'BEGINNER'].includes(product.name.toUpperCase());
  }

  return false;
}